// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"styles_bannerContainer__FAHOo","link":"styles_link__PNmXe"};
module.exports.__checksum = "fb2269eb083e"